import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
export function Privacy() {
  return <LegalLayout title="Política de Privacidad" updated="17 de mayo, 2026" data-id="element-220">
      <section className="legal-section" data-id="element-221">
        <h2 data-id="element-222">Qué información recopilamos</h2>
        <p data-id="element-223">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el material: nombre, dirección de correo
          electrónico, y datos de transacción (procesados por Shopify, nuestro
          proveedor de checkout). No recopilamos información médica ni datos
          sensibles desde esta página.
        </p>
      </section>

      <section className="legal-section" data-id="element-224">
        <h2 data-id="element-225">Cómo usamos la información</h2>
        <p data-id="element-226">
          Tu correo se utiliza para enviarte los archivos del bundle, atender
          solicitudes relacionadas con tu pedido, y — solo si optas por ello —
          comunicaciones futuras de Dermaclinic. Nunca vendemos ni rentamos tu
          información a terceros.
        </p>
      </section>

      <section className="legal-section" data-id="element-227">
        <h2 data-id="element-228">Terceros con acceso limitado</h2>
        <p data-id="element-229">
          Compartimos información estrictamente necesaria con: (1) Shopify Inc.,
          para procesar pagos y entregar archivos; (2) nuestro proveedor de
          envío de correos transaccionales. Ambos operan bajo sus propias
          políticas de privacidad y cumplimiento PCI-DSS.
        </p>
      </section>

      <section className="legal-section" data-id="element-230">
        <h2 data-id="element-231">Tus derechos</h2>
        <p data-id="element-232">
          Puedes solicitar en cualquier momento acceso, corrección o eliminación
          de tus datos personales escribiendo a{' '}
          <a href="mailto:sales@dermaclinicenter.com" data-id="element-233">
            sales@dermaclinicenter.com
          </a>
          . Procesamos solicitudes en un plazo de 30 días.
        </p>
      </section>

      <section className="legal-section" data-id="element-234">
        <h2 data-id="element-235">Cookies</h2>
        <p data-id="element-236">
          Esta página no utiliza cookies de seguimiento publicitario ni pixels
          de terceros. La página de checkout de Shopify utiliza cookies
          funcionales necesarias para procesar la transacción.
        </p>
      </section>

      <section className="legal-section" data-id="element-237">
        <h2 data-id="element-238">Contacto</h2>
        <p data-id="element-239">
          <a href="mailto:sales@dermaclinicenter.com" data-id="element-240">
            sales@dermaclinicenter.com
          </a>
        </p>
      </section>
    </LegalLayout>;
}